export const defaultReportField = {
  name: null,
  sequence: 1,
  freezed: false,
  reference: false,
  collection: false,
};
